import { Fragment } from 'react';
import PropTypes from 'prop-types';
import ResultTableItem from '../../../molecules/screener/result-table-item';
import { augmentClassName } from '../../../../utils/GlobalCssProxy';
import styles from './signature-results.module.scss';

const className = augmentClassName(styles);

export const SignatureResults = ({
  data,
  expandState,
  onClickExpandRow,
  performanceQuarterly,
  isTabletOrMobile,
  isMobile,
  performanceAsOf,
  onChangePerformanceTerm,
  showOnlyMyHoldings
}) => {
  return (
    <Fragment>
      <h3 {...className('heading', 'my-4', 'mt-5', 'font-family-sans-serif')}>
        TIAA signature products
      </h3>
      {data.map((row, index) => {
        if (showOnlyMyHoldings) {
          return (
            row.isOwned && (
              <ResultTableItem
                data-key={`${row.TCWSODIssue || ''}-${index}`}
                key={`${row.TCWSODIssue || ''}-${index}`}
                index={index}
                isExpanded={expandState[index]}
                isSignatureResult={true}
                onClickExpandRow={onClickExpandRow}
                item={row}
                performanceQuarterly={performanceQuarterly}
                performanceAsOf={performanceAsOf}
                onChangePerformanceTerm={onChangePerformanceTerm}
                isTabletOrMobile={isTabletOrMobile}
                isMobile={isMobile}
              />
            )
          );
        }
        return (
          <ResultTableItem
            data-key={`${row.TCWSODIssue || ''}-${index}`}
            key={`${row.TCWSODIssue || ''}-${index}`}
            index={index}
            isExpanded={expandState[index]}
            isSignatureResult={true}
            onClickExpandRow={onClickExpandRow}
            item={row}
            performanceQuarterly={performanceQuarterly}
            performanceAsOf={performanceAsOf}
            onChangePerformanceTerm={onChangePerformanceTerm}
            isTabletOrMobile={isTabletOrMobile}
            isMobile={isMobile}
          />
        );
      })}
    </Fragment>
  );
};

SignatureResults.propTypes = {
  data: PropTypes.array,
  expandState: PropTypes.array,
  onClickExpandRow: PropTypes.func,
  performanceQuarterly: PropTypes.bool,
  performanceAsOf: PropTypes.number,
  isTabletOrMobile: PropTypes.bool,
  isMobile: PropTypes.bool,
  onChangePerformanceTerm: PropTypes.func,
  showOnlyMyHoldings: PropTypes.bool
};
